import { createIcon } from '../icon'
import FreeShippingSmallIcon from '../svg/FreeShippingSmallIcon'

export const FreeShippingSmallIconDefault = createIcon(FreeShippingSmallIcon)
